import jwt_decode from 'jwt-decode';
import { Auth } from 'aws-amplify';
import { CHINA_ACCESS_GROUP } from '../config/regions';

/**
 * Extracts the Cognito groups array from a decoded access token, tolerating
 * both the standard `cognito:groups` claim and the legacy `groups` claim.
 * @param {object} decodedToken
 * @returns {string[]}
 */
export const getGroupsFromToken = (decodedToken) => {
  if (!decodedToken) return [];
  const groups = decodedToken['cognito:groups'] || decodedToken.groups || [];
  return Array.isArray(groups) ? groups : [];
};

/**
 * Synchronous check: does the provided groups array grant China access?
 * @param {string[]} groups
 * @returns {boolean}
 */
export const groupsGrantChinaAccess = (groups) => Array.isArray(groups) && groups.includes(CHINA_ACCESS_GROUP);

/**
 * Resolves whether the currently authenticated user can access the China data
 * region, derived from the `china-access` Cognito group (Phase 1 source of
 * truth). This is a UI gate only; the backend independently re-validates.
 * @returns {Promise<boolean>}
 */
export default async function canAccessChina() {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const { jwtToken } = user.signInUserSession.accessToken;
    const decodedToken = jwt_decode(jwtToken);
    return groupsGrantChinaAccess(getGroupsFromToken(decodedToken));
  } catch (error) {
    return false;
  }
}
